import { FC, Fragment, useState, useEffect } from "react";
import Typography from "@/components/Typography";
import Tag from "@/components/Tag";
import { useInterviewsQuery } from "@/fetch/suppliers";
import { Skeleton } from "@/components/Loader";
import { EmptyJobsList } from "@/components/EmptyList";
import Divider from "@/components/Divider";
import { useTrackers } from "@/hooks";
import Interview from "./Interview";
import styles from "./AppliedTab.module.scss";

type Props = {
  //
};

const AppliedTab: FC<Props> = () => {
  const { data: interviewsData, isLoading } = useInterviewsQuery({
    status: "Applied",
  });

  const { track } = useTrackers();

  useEffect(() => {
    track("Job Matches Tab Viewed", {
      eventId: "job-matches-tab-viewed",
    });
  }, []);

  const interviewStatuses = ["Active", "Inactive"];

  const [selectedStatus, setSelectedStatus] = useState<string>("Active");

  const interviews =
    selectedStatus === "Active"
      ? interviewsData?.active || []
      : interviewsData?.inactive || [];

  return (
    <div className={styles.container}>
      <Typography variant="h6" className={styles.title}>
        Job Matches
      </Typography>
      <div className={styles.tagContainer}>
        {interviewStatuses.map((each) => (
          <Tag
            key={each}
            label={each}
            size="small"
            className={styles.tag}
            variant={each === selectedStatus ? "filled" : "outlined"}
            color={each === selectedStatus ? "success" : "info"}
            onClick={() =>
              setSelectedStatus(each === selectedStatus ? "" : each)
            }
          />
        ))}
      </div>
      {isLoading ? (
        <Skeleton variant="rectangular" height={200} />
      ) : (
        <>
          {interviews.length > 0 ? (
            <>
              <Typography
                color="text.secondary"
                variant="body1"
                className={styles.cardTitle}
              >
                {selectedStatus === "Active"
                  ? "In progress job interviews"
                  : "Inactive job interviews"}
              </Typography>
              {interviews.map((eachInterview, idx) => (
                <Fragment key={eachInterview.id}>
                  <Interview
                    interview={eachInterview}
                    showStatus={selectedStatus !== "Active"}
                  />
                  {/* {idx !== interviews.length - 1 && (
                    <Divider className={styles.divider} />
                  )} */}
                </Fragment>
              ))}

              {selectedStatus === "Active" && (
                <div className={styles.tipsContainer}>
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    className={styles.tipTitle}
                  >
                    Important Tips
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    className={styles.tipSubject}
                  >
                    Unlimited Job Interviews
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.primary"
                    className={styles.tipText}
                  >
                    {`We are proud to offer unlimited job interviews to our Global
            Travellers (on our "Plus" trips), so long as you give at least 4
            weeks advance notice upon completing your commitment with the
            Partner Organisation and remained professional at all times.`}
                  </Typography>

                  <Typography
                    variant="body1"
                    color="text.secondary"
                    className={styles.tipSubject}
                  >
                    Interview tips
                  </Typography>
                  <Typography variant="body2" color="text.primary">
                    {`Give yourself a head start by reviewing the Partner Organisation’s
            website before your interview so you have a strong understanding of
            their company. Be prepared ahead of time - this means wearing a
            professional outfit, ensuring your internet connection is stable (if
            video calling) and write yourself a list of questions you'd like to ask.
            And, this should go without saying, be on time (that means 5-10
            minutes early!).`}
                  </Typography>
                </div>
              )}
            </>
          ) : (
            <EmptyJobsList variant="applied" />
          )}
        </>
      )}
    </div>
  );
};

export default AppliedTab;
